import { Link } from "react-router-dom";

import { formatarDataHoraISO } from "../../lib/formato/data";
import type { FilaResumo } from "../../lib/dashboard/tipos";

/*
 * Card da fila de conciliação no dashboard (Tela 1). Mostra a contagem de
 * pendentes e o instante do último movimento conciliado, com link "Ver fila" →
 * /conciliacao.
 *
 * `ultimo_conciliado` é um datetime ISO ou null → exibe "—" quando null
 * (`formatarDataHoraISO` só formata datetime válido). Fila vazia
 * (`pendentes === 0`) → "Fila vazia". Só tokens CPMH.
 */

interface FilaPendentesProps {
  fila: FilaResumo;
}

export function FilaPendentes({ fila }: FilaPendentesProps): JSX.Element {
  const ultimo =
    fila.ultimo_conciliado === null
      ? "—"
      : formatarDataHoraISO(fila.ultimo_conciliado);

  return (
    <section className="rounded-lg border border-platinum bg-snow p-4">
      <div className="flex items-baseline justify-between">
        <h2 className="font-subtitulo text-base text-off-black">
          Fila de conciliação
        </h2>
        <Link to="/conciliacao" className="text-flame hover:underline">
          Ver fila
        </Link>
      </div>

      {fila.pendentes === 0 ? (
        <p className="font-corpo text-base text-off-black">Fila vazia</p>
      ) : (
        <p className="font-titulo text-2xl text-off-black">
          {fila.pendentes} pendente(s)
        </p>
      )}

      <p className="font-corpo text-sm text-off-black">
        Último conciliado: {ultimo}
      </p>
    </section>
  );
}
